module.exports = __webpack_public_path__ + "img/16d001-20.5cf9fa2b.jpg";